import React from "react";
import "./SuiteHeader.scss";
import Tenant from "../../../components/Tenant";
import Avatar from "../../../components/Avatar";
import { onRequestPhoneCall } from "../../../helpers/validationHelper";
import { Link } from "react-router-dom";

export const Headline = ({
  suiteName = "",
  showProfile,
  profileLinkTo,
  disableLink,
  name,
  phone,
  image,
}) => (
  <div className="suite-header__container">
    <div className="suite-header__title">
      <h1>{suiteName}</h1>
    </div>

    {showProfile && (
      <div className="suite-header__user">
        <LinkWrapper to={profileLinkTo ?? {}} disabled={disableLink}>
          <Tenant
            left
            headline={name}
            strapline={onRequestPhoneCall(phone)}
            avatar={<Avatar url={image} />}
          />
        </LinkWrapper>
      </div>
    )}
  </div>
);

const LinkWrapper = ({ to, disabled, children }) => {
  if (!to || disabled) {
    return children;
  }
  return <Link to={to}>{children}</Link>;
};
